<template>
  <div class="assitApply">
    <a-spin tip="Loading..." :spinning="spinning">
      <div class="spin-content">
        <div style="margin:18px 0">
          <Breadcrumb :breadcrumb="breadcrumb" />
        </div>
        <div style="padding:20px 29px 0;background: #fff;border-radius:2px;">
          <cardTitle title="活动基本信息" />
          <div style="margin-top:18px;">
            <activeBaseForm
              ref="activeBaseForm"
              :initData="{
                ...initData.init_value.process_base_table_message,
                process_base_title: initData.init_value.process_base_title || ''
              }"
              :checkDisplay="checkDisplay"
              :checkDisabled="checkDisabled"
            />
            <Volunteer
              :approvalPeople="initData.activity_volunteer || []"
              ref="volunteer"
              :pageType="pageType"
            />
          </div>
        </div>
        <div style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;">
          <cardTitle title="帮扶对象名单" />
          <div style="margin-top:18px;">
            <assitPeopleSelect
              ref="assitPeople"
              :selectAssitPeople="assitPeople"
              :pageType="pageType"
              :checkDisplay="checkDisplay"
            />
          </div>
        </div>
        <div style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;">
          <cardTitle title="领导选择" />
          <div style="margin-top:18px;">
            <leader-select
              :approvalPeople="initData.process_config || []"
              ref="leaderList"
              :pageType="pageType"
            />
          </div>
        </div>
        <div style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;">
          <cardTitle title="通知阅读" />
          <div style="margin-top:18px;">
            <Noticeread
              :approvalPeople="initData.notice_reader || []"
              ref="noticeRead"
              :pageType="pageType"
            />
          </div>
        </div>
        <div
          style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
          v-if="checkDisplay('approvalList')"
        >
          <cardTitle title="活动审批" />
          <div style="margin-top:18px;" class="table">
            <ApprovalList :dataSource="initData.process_business_message || []" />
          </div>
        </div>
        <div
          style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
          v-if="checkDisplay('approval')"
        >
          <cardTitle title="审批" />
          <div style="margin-top:18px;">
            <Approval :approvalInfo="{ approvalResult: '', approvalOpinion: '' }" ref="approval" />
            <!--<leader-select :approvalPeople="initData.process_config || []" ref="leaderList"/>-->
          </div>
        </div>
        <div
          v-if="checkDisplay('activeReport')"
          style="padding:20px 29px;background: #fff;border-radius:2px;margin-top:11px;"
        >
          <cardTitle title="活动报告" />
          <div style="margin-top:18px;" class="activeReport">
            <activeReport
              :workFlowNumber="initData.init_value || {}"
              ref="activeReport"
              :checkDisabled="checkDisabled"
              :fileList="initData.report_file || []"
            />
          </div>
        </div>
        <div
          class="formButton"
          style="margin-top:20px;text-align: right"
          v-if="checkDisplay('button')"
        >
          <a-button type="primary" @click="saveDraft" v-if="checkDisplay('save')">
            保存
          </a-button>
          <a-button
            type="primary"
            :style="{ marginLeft: '8px' }"
            @click="onSubmit"
            v-if="checkDisplay('submit')"
          >
            提交
          </a-button>
          <a-button
            type="primary"
            :style="{ marginLeft: '8px' }"
            @click="() => onConfirm(true)"
            v-if="checkDisplay('confirm')"
          >
            同意
          </a-button>
          <a-button
            type="primary"
            :style="{ marginLeft: '8px' }"
            @click="() => onConfirm()"
            v-if="checkDisplay('confirm')"
          >
            不同意
          </a-button>
          <a-button
            :style="{ marginLeft: '8px' }"
            @click="goToHistory"
            v-if="checkDisplay('cancel')"
          >
            取消
          </a-button>
        </div>
      </div>
    </a-spin>
  </div>
</template>

<script>
import Breadcrumb from '@/components/breadcrumb'
import cardTitle from '../../components/cardTitle'
import Form from '@/components/GlobalForm'
import activeBaseForm from '../../components/activeBaseForm'
import ApprovalList from '../../components/approval'
import { mapActions } from 'vuex'
import BaseForm from '../../components/baseForm'
import Volunteer from '@/components/volunteer'

// import SelectPeople from '@/components/selectPeople'
import Approval from '@/components/approval'
import { service } from './service'
import SelectPeople from '@/components/selectPeople'

import leaderSelect from '@/components/leaderSelect'
import { forms } from './formData'
import assitPeopleSelect from '@/components/assitPeople'
import Noticeread from '@/components/noticeReader'
import activeReport from '@/components/activeReport'

export default {
  name: 'Index',
  components: {
    Breadcrumb,
    Volunteer,
    cardTitle,
    activeBaseForm,
    ApprovalList,
    Approval,
    leaderSelect,
    Form,
    BaseForm,
    SelectPeople,
    assitPeopleSelect,
    Noticeread,
    activeReport
  },
  data() {
    return {
      spinning: true,
      isFinish: false,
      pageType: 'launch', // 拟稿
      // columns, // 人员列表头数据,可编辑
      // viewColumns, // 人员列表头数据，只读
      initData: { init_value: {} }, // 表单默认数据
      processConfigType: 'ghActivityConfirmation', // 流程类型
      // selectPeopleVisible: false, // 选人弹出框
      assitPeople: [], // 已选的帮扶对象
      // dataSource: [], // 帮扶对象源数据
      // selectedKeys: [], // 已选人员的key集合
      processData: {}, // 页面带过来的流程关键数据
      breadcrumb: [
        {
          // 面包屑
          title: '综合帮扶',
          path: ''
        },
        {
          title: '帮侬一把',
          path: '/assit/compositeAssit/givemeaHand'
        },
        {
          title: '活动帮扶申请',
          path: ''
        }
      ]
    }
  },
  created() {
    // const userInfo = this.$store.getters.userInfo ? this.$store.getters.userInfo.user : {}
    // const permission = userInfo.user_permissions || []
    // const isShow = permission.filter(value => value === 'giveMe')
    // if (!isShow || isShow.length <= 0) { // 无权限时
    //   if (this.$route.query && this.$route.query.pageType && this.$route.query.pageType === 'view') { // 判断页面跳转带过来的页面类型的值
    //     this.pageType = 'view'// 可以查看
    //     this.processData = this.$route.query.processData ? JSON.parse(this.$route.query.processData) : {}
    //     this.isFinish = this.processData.process_base_status ? (this.processData.process_base_status === 'Finish') : false
    //   } else if (this.$route.query && this.$route.query.pageType && this.$route.query.pageType === 'approval') {
    //     this.pageType = 'approval'// 可以审批
    //     this.processData = this.$route.query.processData ? JSON.parse(this.$route.query.processData) : {}
    //     this.isFinish = this.processData.process_base_status ? (this.processData.process_base_status === 'Finish') : false
    //   } else if (this.$route.query && this.$route.query.pageType && this.$route.query.pageType === 'approvalFund') { // 退回拟稿
    //     this.pageType = 'approvalFund'
    //     this.processData = this.$route.query.processData ? JSON.parse(this.$route.query.processData) : {}
    //     this.isFinish = this.processData.process_base_status ? (this.processData.process_base_status === 'Finish') : false
    //   } else {
    //     this.$router.push({ path: '123' })
    //   }
    // } else { // 有权限时
    if (this.$route.query && this.$route.query.pageType) {
      // 判断页面跳转带过来的页面类型的值
      if (this.$route.query.pageType === 'approval') {
        // 审批
        this.pageType = 'approval'
      } else if (this.$route.query.pageType === 'draft') {
        // 草稿
        this.pageType = 'draft'
      } else if (this.$route.query.pageType === 'launch') {
        // 发起
        this.pageType = 'launch'
      } else if (this.$route.query.pageType === 'relaunch') {
        // 退回拟稿
        this.pageType = 'relaunch'
      } else if (this.$route.query.pageType === 'view') {
        // 退回拟稿
        this.pageType = 'view'
      } else if (this.$route.query.pageType === 'edit') {
        // 退回拟稿
        this.pageType = 'edit'
      } else if (this.$route.query.pageType === 'approvalFund') {
        // 退回拟稿
        this.pageType = 'approvalFund'
      }
      this.processData = this.$route.query.processData
        ? JSON.parse(this.$route.query.processData)
        : {}
      this.isFinish = this.processData.process_base_status
        ? this.processData.process_base_status === 'Finish'
        : false
    }
    // }
  },
  mounted() {
    if (this.pageType === 'launch') {
      // 拟稿
      this.InitProcess({ processConfigType: this.processConfigType }).then((response) => {
        this.initData = this._.cloneDeep(response || {})
        if (
          this.initData &&
          this.initData.init_value &&
          this.initData.init_value.process_base_table_message &&
          this.initData.init_value.process_base_table_message.need_help_person
        ) {
          this.assitPeople =
            this.initData.init_value.process_base_table_message.need_help_person || []
          // this.selectedKeys = this.getSelectedKeys(this.assitPeople)
        }
        this.spinning = false
      })
    } else {
      const params = {
        process_base_work_number: this.processData.process_base_work_number
      }
      this.GetTaskBusinessData(params).then((response) => {
        this.initData = this._.cloneDeep(response || {})
        if (
          this.initData &&
          this.initData.init_value &&
          this.initData.init_value.process_base_table_message &&
          this.initData.init_value.process_base_table_message.need_help_person
        ) {
          this.assitPeople =
            this.initData.init_value.process_base_table_message.need_help_person || []
          // this.selectedKeys = this.getSelectedKeys(this.assitPeople)
        }
        this.spinning = false
      })
    }
  },
  computed: {
    getActiveForm() {
      // 活动文件
      return forms.getBaseForm({}, this)
    }
  },
  methods: {
    ...mapActions(['InitProcess', 'GetTaskBusinessData']), // vuex中的获取初始表单数据方法
    // 判断是否展示,返回true就展示，false不展示
    checkDisplay(type) {
      if (this.pageType === 'launch') {
        // 页面为拟稿时，审批列表和审批控件都不展示
        switch (
          type // 审批列表
        ) {
          case 'approvalList':
            return false
          case 'confirm':
            return false
          case 'approval': // 审批控件
            return false
          case 'activeReport': // 活动报告
            return false
        }
      } else if (this.pageType === 'approval') {
        switch (type) {
          case 'personButton': // 帮扶对象名单按钮
            return false
          case 'activeUpload': // 审批时上传活动报告的按钮不展示
            return false
          case 'confirm':
            return false
          case 'save':
            return false // 审批时保存按钮不生成
          case 'item':
            return false // 项目选择提醒
          case 'unit':
            return false // 执行单位选择提醒
        }
      } else if (this.pageType === 'draft') {
        switch (
          type // 审批列表
        ) {
          case 'approvalList':
            return false
          case 'confirm':
            return false
          case 'approval':
            return false // 审批控件
          case 'activeReport': // 活动报告
            return false
        }
      } else if (this.pageType === 'relaunch') {
        switch (type) {
          case 'approval':
            return false // 审批控件
          case 'confirm':
            return false
          case 'save':
            return false // 审批时保存按钮不生成
          case 'activeReport': // 活动报告
            return false
        }
      } else if (this.pageType === 'view' || this.pageType === 'edit') {
        switch (type) {
          case 'personButton': // 帮扶对象名单按钮
            return false
          case 'activeUpload': // 只读时上传活动报告的按钮不展示
            return false
          case 'button':
            return false // 只读时按钮不生成
          case 'approval':
            return false // 审批控件
          case 'item':
            return false // 项目选择提醒
          case 'unit':
            return false // 执行单位选择提醒
        }
      } else if (this.pageType === 'view' || this.pageType === 'edit') {
        switch (type) {
          case 'personButton': // 帮扶对象名单按钮
            return false
          case 'activeUpload': // 只读时上传活动报告的按钮不展示
            return false
          case 'save':
            return false // 只读时按钮不生成
          case 'submit':
            return false // 只读时按钮不生成
          case 'approval':
            return false // 审批控件
          case 'item':
            return false // 项目选择提醒
          case 'unit':
            return false // 执行单位选择提醒
        }
      }
      if (type === 'activeReport') {
        if (this.isFinish) {
          return true
        }
        return false
      }
      return true
    },
    // 判断每个控件是否只读，不能更改，如果只读返回true，否则返回false
    checkDisabled(type) {
      if (
        this.pageType === 'approval' ||
        this.pageType === 'view' ||
        this.pageType === 'approvalFund'
      ) {
        switch (
          type // 审批控件
        ) {
          default:
            return true
        }
      } else if (
        this.pageType === 'launch' ||
        this.pageType === 'relaunch' ||
        this.pageType === 'draft'
      ) {
        switch (
          type // 审批控件
        ) {
          default:
            return false
        }
      } else if (this.pageType === 'edit') {
        switch (
          type // 审批控件
        ) {
          case 'activeReport':
            return false
          default:
            return true
        }
      }
    },
    // 下一步处理人弹出框
    nextStepHandler(params, data) {
      this.$confirm({
        title: data,
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.submit(params) // 提交
        },
        onCancel: () => {
          this.spinning = false
        }
      })
    },
    // 判断所填申请金额与人员金额总和
    checkMoney(data, money) {
      let sum = 0
      for (let i = 0; i < data.length; i++) {
        sum = parseFloat(sum + parseFloat(data[i].need_help_assistance_amount || 0)).toFixed(2)
      }
      if (sum > parseFloat(money.activity_funding || 0)) {
        this.$notification.error({
          message: '帮扶对象总金额不能大于所填活动资金金额'
        })
        return false
      }
      return true
    },
    // 表单发起提交查找下一步处理人
    onSubmit() {
      if (this.pageType === 'launch' || this.pageType === 'relaunch' || this.pageType === 'draft') {
        const baseData = this.$refs.activeBaseForm.onSubmit()
        const leaderList = this.$refs.leaderList.onSubmit()
        const assitPeople = this.$refs.assitPeople.getValue()
        const noticeReader = this.$refs.noticeRead.getValue()
        const volunteer = this.$refs.volunteer.getValue() // 志愿者
        if (this.pageType === 'launch' || this.pageType === 'relaunch') {
          if (!this.checkMoney(assitPeople, baseData)) {
            return null
          }
        }

        if (leaderList) {
          this.spinning = true
          service
            .nextStepHandler({
              baseData,
              volunteer,
              noticeReader,
              leaderList,
              assitPeople,
              pageType: this.pageType
            })
            .then((response) => {
              this.nextStepHandler(
                {
                  baseData,
                  volunteer,
                  noticeReader,
                  leaderList,
                  assitPeople,
                  pageType: this.pageType
                },
                response
              )
            })
        }
      } else if (this.pageType === 'approval') {
        const approvalInfo = this.$refs.approval.onSubmit()
        if (approvalInfo) {
          this.spinning = true
          service.nextStepHandler({ approvalInfo, pageType: this.pageType }).then((response) => {
            this.nextStepHandler({ approvalInfo, pageType: this.pageType }, response)
          })
        }
      }
    },
    // 发起提交
    submit(params) {
      if (this.pageType === 'approval' || this.pageType === 'relaunch') {
        // 当是审批和退回拟稿的时候，提交走处理接口
        service.dispatchTask(params).then((response) => {
          this.$notification.success({
            message: '审批成功'
          })
          this.spinning = false
          this.$router.push({ path: '/assit/personal' })
          // this.goToHistory()
        })
      } else if (this.pageType === 'launch' || this.pageType === 'draft') {
        // 当是拟稿或者草稿发起的时候，走发起接口
        service.launchTask(params).then((response) => {
          this.$notification.success({
            message: '提交成功'
          })
          this.spinning = false
          this.$router.push({ path: '/assit/personal' })
          // this.goToHistory()
        })
      }
    },
    // 流程保存
    saveDraft() {
      const baseData = this.$refs.activeBaseForm.onSubmit()
      const leaderList = this.$refs.leaderList.getValue()
      const assitPeople = this.$refs.assitPeople.getValue()
      const noticeReader = this.$refs.noticeRead.getValue()
      const volunteer = this.$refs.volunteer.getValue() // 志愿者

      this.spinning = true
      service
        .saveProcessDraft({
          baseData,
          volunteer,
          noticeReader,
          leaderList,
          assitPeople,
          pageType: this.pageType
        })
        .then((response) => {
          this.$notification.success({
            message: '保存成功'
          })
          this.spinning = false
          // this.$router.push({ path: '/assit/personal' })
          // this.goToHistory()
        })
    },
    // 资金确认
    onConfirm(type) {
      this.spinning = true
      service.fundingApproval(type).then((response) => {
        this.$notification.success({
          message: '审批成功'
        })
        this.spinning = false
        this.goToHistory()
      })
    },
    // 取消返回上一页
    goToHistory() {
      this.$router.go(-1) // 返回上一层
    }
  }
}
</script>

<style scoped lang="less">
@import '../../../style.less';
.assitApply {
  .activeReport {
    .upload {
      display: inline-block;
      color: #3d73dd;
      /*margin-left:10px;*/
      cursor: pointer;
    }
    .upload:hover {
      color: #4d86ff;
    }
  }
  .personList {
    position: relative;
    border: 1px solid #e8e8e8;
    /deep/ .ant-table-wrapper {
      /*border:1px solid #e8e8e8;*/
      border-radius: 2px;
    }
    /deep/ .ant-table-placeholder {
      border-bottom: none;
    }
  }
}
</style>
